/**
 * Utility to preload images into the browser's disk cache.
 */
export const preloadImages = (urls: string[]) => {
    urls.forEach(url => {
        if (!url || url.startsWith('generated://')) return;

        const img = new Image();
        img.src = url;
    });
};

/**
 * Preload covers specifically for a list of books.
 * Limits to a subset to avoid excessive network usage.
 */
export const preloadBookCovers = (books: any[], limit: number = 20) => {
    const urls = books
        .slice(0, limit)
        .map(book => book.coverUrl || book.cover)
        .filter(url => !!url);

    preloadImages(urls);
};
